import * as ACTION_TYPE from "./constants";
import { loaderState } from "../reducerStateUpdaters";

const { initLoader, setLoading, setDataLoaded, setError, resetErrorAndLoading } =
  loaderState;

const initialState = {
  messages: initLoader(),
  unseenCount: initLoader(),
  pagination: {
    from: 0,
    to: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "REDUX_STORAGE_LOAD":
      return {
        ...state,
        messages: resetErrorAndLoading(state.messages),
        unseenCount: resetErrorAndLoading(state.unseenCount),
      };

    case ACTION_TYPE.LOAD_IN_APP_MESSAGES.STARTED:
      return {
        ...state,
        messages: setLoading(state.messages),
        pagination: {
          from:
            action.payload && typeof action.payload.from === "number"
              ? action.payload.from
              : state.pagination.from,
          to:
            action.payload && typeof action.payload.to === "number"
              ? action.payload.to
              : state.pagination.to,
        },
      };

    case ACTION_TYPE.LOAD_IN_APP_MESSAGES.SUCCESS:
      return {
        ...state,
        messages: setDataLoaded(state.messages, action.payload.messages),
        pagination: {
          from: action.payload.from,
          to: action.payload.to,
        },
      };

    case ACTION_TYPE.LOAD_IN_APP_MESSAGES.FAILED:
      return {
        ...state,
        messages: setError(state.messages, action.payload.error),
      };

    case ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.STARTED:
      return {
        ...state,
        unseenCount: setLoading(state.unseenCount),
      };

    case ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.SUCCESS:
      return {
        ...state,
        unseenCount: setDataLoaded(state.unseenCount, action.payload.count),
      };

    case ACTION_TYPE.LOAD_UNSEEN_MESSAGES_COUNT.FAILED:
      return {
        ...state,
        unseenCount: setError(state.unseenCount, action.payload.error),
      };

    case ACTION_TYPE.MARK_MESSAGE_AS_SEEN.STARTED:
      // Optimistic update - immediately mark messages as seen
      const unseenBeingMarked = state.messages.data.filter(
        (message) => action.payload.messageIds.includes(message.id) && !message.seenAt
      ).length;
      
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map((message) =>
            action.payload.messageIds.includes(message.id)
              ? { ...message, seenAt: new Date().toISOString(), _optimisticSeen: true }
              : message
          ),
        },
        unseenCount: {
          ...state.unseenCount,
          data: Math.max(0, (state.unseenCount.data || 0) - unseenBeingMarked),
          _optimisticCount: unseenBeingMarked,
        },
      };

    case ACTION_TYPE.MARK_MESSAGE_AS_SEEN.SUCCESS:
      // Remove optimistic flag on success
     if (action.payload.isSuccess) {
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map((message) =>
            action.payload.messageIds.includes(message.id)
              ? { ...message, seenAt: new Date().toISOString(), _optimisticSeen: undefined }
              : message
          ),
        },
        unseenCount: {
          ...state.unseenCount,
          _optimisticCount: undefined,
        },
      };
     }

    case ACTION_TYPE.MARK_MESSAGE_AS_SEEN.FAILED:
      // Rollback optimistic update on failure
      const rollbackCount = state.unseenCount._optimisticCount || 0;
      
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map((message) =>
            action.payload.messageIds.includes(message.id) && message._optimistic
              ? { ...message, seenAt: undefined, _optimisticSeen: undefined }
              : message
          ),
        },
        unseenCount: {
          ...state.unseenCount,
          data: (state.unseenCount.data || 0) + rollbackCount,
          _optimisticCount: undefined,
        },
      };

    case ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.STARTED:
      // Optimistic update - immediately mark messages as hidden
      const hiddenUnseenCount = state.messages.data.filter(
        (message) => action.payload.messageIds.includes(message.id) && !message.seenAt
      ).length;
      
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map((message) =>
            action.payload.messageIds.includes(message.id)
              ? { ...message, hiddenAt: new Date().toISOString(), _optimisticHidden: true }
              : message
          ),
        },
        unseenCount: {
          ...state.unseenCount,
          data: Math.max(0, (state.unseenCount.data || 0) - hiddenUnseenCount),
          _optimisticCount: hiddenUnseenCount,
        },
      };

    case ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.SUCCESS:
      // Remove optimistic flag on success
      if (action.payload.isSuccess) {
        return {
          ...state,
          messages: {
            ...state.messages,
            data: state.messages.data.map((message) =>
              action.payload.messageIds.includes(message.id)
                ? { ...message, hiddenAt: new Date().toISOString(), _optimisticHidden: undefined }
                : message
            ),
          },
          unseenCount: {
            ...state.unseenCount,
            _optimisticCount: undefined,
          },
        };
      }
      return state;

    case ACTION_TYPE.MARK_MESSAGE_AS_HIDDEN.FAILED:
      // Rollback optimistic update on failure
      const rollbackHiddenCount = state.unseenCount._optimisticHiddenCount || 0;
      
      return {
        ...state,
        messages: {
          ...state.messages,
          data: state.messages.data.map((message) =>
            action.payload.messageIds.includes(message.id) && message._optimisticHidden
              ? { ...message, hiddenAt: undefined, _optimisticHidden: undefined }
              : message
          ),
        },
        unseenCount: {
          ...state.unseenCount,
          data: (state.unseenCount.data || 0) + rollbackHiddenCount,
          _optimisticCount: undefined,
        },
      };

    default:
      return state;
  }
};
